<template>
  <navbar btn-background="bg-gradient-primary" />
  <div
    class="pt-5 m-3 page-header align-items-start min-vh-50 pb-11 border-radius-lg"
    :style="{
      backgroundImage:
        'url(' + require('@/assets/img/curved-images/curved9.jpg') + ')',
    }"
  >
    <span class="mask bg-gradient-success opacity-6"></span>
  </div>
  <div class="container">
    <div class="row mt-lg-n10 mt-md-n11 mt-n10 justify-content-center">
      <div class="col-xl-12 col-lg-12 col-md-9 col-sm-11">
        <div class="card z-index-0">
          <!-- Invalid / loading token state -->
          <div v-if="tokenLoading" class="pt-5 pb-5 text-center">
            <h5>Validating your invitation...</h5>
          </div>
          <div v-else-if="!tokenValid" class="pt-5 pb-5 text-center">
            <h5 class="text-danger">Invalid Invitation</h5>
            <p class="text-muted px-4">
              {{ tokenError }}
            </p>
            <router-link to="/sign-in" class="btn btn-sm btn-success mt-3">
              Go to Sign In
            </router-link>
          </div>

          <!-- Valid token: show registration form -->
          <template v-else>
            <div class="pt-4 text-center card-header">
              <h5>BFMSCare Employee Registration</h5>
              <p class="text-muted mb-0">You've been invited to create your account.</p>
            </div>
            <div class="card-body">
              <form @submit.prevent="handleSubmit" role="form">
                <div class="mb-3">
                  <label for="first_name">First Name</label>
                  <soft-input
                    v-model="formData.first_name"
                    id="first_name"
                    type="text"
                    placeholder="First Name"
                  />
                </div>
                <div class="mb-3">
                  <label for="last_name">Last Name</label>
                  <soft-input
                    v-model="formData.last_name"
                    id="last_name"
                    type="text"
                    placeholder="Last Name"
                  />
                </div>
                <div class="mb-3">
                  <label for="date_of_birth">Date of Birth</label>
                  <soft-input
                    v-model="formData.date_of_birth"
                    id="date_of_birth"
                    type="date"
                  />
                </div>
                <div class="mb-3">
                  <label for="address">Address</label>
                  <soft-input
                    v-model="formData.address"
                    id="address"
                    type="text"
                    placeholder="Address"
                  />
                </div>
                <div class="mb-3">
                  <label for="city">City</label>
                  <soft-input
                    v-model="formData.city"
                    id="city"
                    type="text"
                    placeholder="City"
                  />
                </div>
                <div class="mb-3">
                  <label for="state">State</label>
                  <soft-input
                    v-model="formData.state"
                    id="state"
                    type="text"
                    placeholder="State"
                  />
                </div>
                <div class="mb-3">
                  <label for="zip_code">ZIP Code</label>
                  <soft-input
                    v-model="formData.zip_code"
                    id="zip_code"
                    type="number"
                    placeholder="ZIP Code"
                  />
                </div>
                <div class="mb-3">
                  <label class="form-label d-block">Gender</label>
                  <div class="form-check form-check-inline">
                    <input
                      type="radio"
                      id="gender_male"
                      name="gender"
                      value="Male"
                      v-model="formData.gender"
                      class="form-check-input"
                    />
                    <label class="form-check-label" for="gender_male">Male</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      type="radio"
                      id="gender_female"
                      name="gender"
                      value="Female"
                      v-model="formData.gender"
                      class="form-check-input"
                    />
                    <label class="form-check-label" for="gender_female">Female</label>
                  </div>
                </div>
                <div class="mb-3">
                  <label for="contact_number">Phone Number</label>
                  <soft-input
                    v-model="formData.contact_number"
                    v-mask="'(+1) ### ### ####'"
                    id="contact_number"
                    type="text"
                    placeholder="Phone Number"
                  />
                </div>
                <div class="mb-3">
                  <label for="ss_number">SS Number</label>
                  <soft-input
                    v-model="formData.ss_number"
                    v-mask="'###-##-####'"
                    id="ss_number"
                    type="text"
                    placeholder="123-45-6789"
                  />
                </div>
                <div class="mb-3">
                  <label for="uci_number">Client's UCI number</label>
                  <soft-input
                    v-model="formData.uci_number"
                    id="uci_number"
                    type="text"
                    placeholder="Client's UCI number"
                  />
                </div>
                <div class="mb-3">
                  <label for="email">Email</label>
                  <soft-input
                    v-model="formData.email"
                    id="email"
                    type="email"
                    placeholder="Email Address"
                    :disabled="emailLocked"
                  />
                  <small v-if="emailLocked" class="text-muted">
                    Email is pre-filled from your invitation.
                  </small>
                </div>
                <div class="mb-3">
                  <label for="password">Password</label>
                  <soft-input
                    v-model="formData.password"
                    id="password"
                    type="password"
                    placeholder="Password"
                  />
                </div>
                <div class="mb-3">
                  <label for="confirm_password">Confirm Password</label>
                  <soft-input
                    v-model="formData.confirm_password"
                    id="confirm_password"
                    type="password"
                    placeholder="Confirm Password"
                  />
                </div>
                <soft-checkbox
                  id="flexCheckDefault"
                  name="terms"
                  :checked="formData.terms"
                  @change="(e) => (formData.terms = e.target.checked)"
                  class="font-weight-light"
                >
                  I agree the
                  <a href="javascript:;" class="text-dark font-weight-bolder"
                    >Terms and Conditions</a
                  >
                </soft-checkbox>
                <div class="text-center">
                  <soft-button
                    type="submit"
                    color="success"
                    full-width
                    variant="gradient"
                    class="my-4 mb-2"
                    >Create Account</soft-button
                  >
                </div>
              </form>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "@/examples/PageLayout/Navbar.vue";
import SoftInput from "@/components/SoftInput.vue";
import SoftCheckbox from "@/components/SoftCheckbox.vue";
import SoftButton from "@/components/SoftButton.vue";
import Swal from "sweetalert2";
import axios from "axios";
export default {
  name: "SignupBasic",
  components: {
    Navbar,
    SoftInput,
    SoftCheckbox,
    SoftButton,
  },
  data() {
    return {
      invitationToken: "",
      tokenLoading: true,
      tokenValid: false,
      tokenError: "",
      emailLocked: false,
      formData: {
        first_name: "",
        last_name: "",
        contact_number: "",
        gender: "",
        date_of_birth: "",
        address: "",
        city: "",
        state: "",
        zip_code: "",
        ss_number: "",
        uci_number: "",
        email: "",
        password: "",
        confirm_password: "",
        terms: false,
      },
      errors: [],
    };
  },
  async mounted() {
    const token = this.$route.query.token;
    if (!token) {
      this.tokenLoading = false;
      this.tokenValid = false;
      this.tokenError =
        "This page requires a valid invitation link. Please ask your employer to send you an invite.";
      return;
    }
    this.invitationToken = token;
    try {
      const res = await axios.post(
        `${process.env.VUE_APP_BACKEND_DOMAIN}/api/validate_invitation`,
        { token }
      );
      if (res.data.valid) {
        this.tokenValid = true;
        if (res.data.email) {
          this.formData.email = res.data.email;
          this.emailLocked = true;
        }
      } else {
        this.tokenValid = false;
        this.tokenError = res.data.message || "Invalid invitation link.";
      }
    } catch (err) {
      this.tokenValid = false;
      this.tokenError =
        err.response?.data?.message ||
        "This invitation link is invalid or has already been used.";
    } finally {
      this.tokenLoading = false;
    }
  },
  methods: {
    async handleSubmit() {
      this.errors = [];
      if (!this.formData.first_name)
        this.errors.push("First name is required.");
      if (!this.formData.last_name) this.errors.push("Last name is required.");
      if (!this.formData.contact_number)
        this.errors.push("Phone number is required.");
      if (!this.formData.ss_number) this.errors.push("SS number is required.");
      if (!this.formData.gender) this.errors.push("Gender is required.");
      if (!this.formData.date_of_birth)
        this.errors.push("Date of Birth is required.");
      if (!this.formData.address) this.errors.push("Address is required.");
      if (!this.formData.city) this.errors.push("City is required.");
      if (!this.formData.state) this.errors.push("State is required.");
      if (!this.formData.zip_code) this.errors.push("Zip Code is required.");
      if (!this.formData.uci_number)
        this.errors.push("Client's UCI number is required.");
      if (!this.formData.email) this.errors.push("Email is required.");
      if (this.formData.password.length < 8)
        this.errors.push("Password must be at least 8 characters.");
      if (this.formData.password !== this.formData.confirm_password)
        this.errors.push("Passwords do not match.");
      if (!this.formData.terms)
        this.errors.push("You must agree to the terms.");

      if (this.errors.length) {
        Swal.fire({
          icon: "error",
          title: "Please fix the following:",
          html: this.errors.map((e) => `<p>${e}</p>`).join(""),
          didOpen: () => {
            const swalContent = Swal.getHtmlContainer();
            if (swalContent) swalContent.style.textAlign = "left";
          },
        });
        return;
      }

      Swal.fire({
        title: "Creating your account...",
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => Swal.showLoading(),
      });

      try {
        const formDataToSend = new FormData();
        formDataToSend.append("invitation_token", this.invitationToken);
        for (const key in this.formData) {
          if (key !== "confirm_password" && key !== "terms") {
            formDataToSend.append(key, this.formData[key]);
          }
        }

        const response = await axios.post(
          `${process.env.VUE_APP_BACKEND_DOMAIN}/api/add_employee`,
          formDataToSend,
          { headers: { "Content-Type": "multipart/form-data" } }
        );

        if (response.data.status === 201) {
          Swal.fire({
            title: "Account Created!",
            text: "Please wait for the admin to activate your account. You can then sign in.",
            icon: "success",
          }).then(() => {
            this.$router.push({ name: "Sign In" });
          });
        }
      } catch (error) {
        if (error.response && error.response.status === 422) {
          const errors = error.response.data.errors;
          const errorMessages = Object.values(errors).flat().join("\n");
          Swal.fire({
            title: "Registration Failed",
            text: errorMessages,
            icon: "error",
          });
        } else {
          Swal.fire({
            title: "Something went wrong",
            text: "Please try again later.",
            icon: "error",
          });
        }
      }
    },
  },
};
</script>
